import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgIconsModule } from '@ng-icons/core';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Appointment } from 'src/app/models/appointment.model';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'ubc-appointment-rating',
  standalone: true,
  imports: [NgIconsModule, CommonModule],
  templateUrl: './appointment-rating.component.html',
  styleUrl: './appointment-rating.component.scss'
})
export class AppointmentRatingComponent {
  stars = [1, 2, 3, 4, 5];
  @Input() appointment: Appointment
  hoveredRating = 0;

  constructor(
    private apiService: APIServiceService,
    private notificationService: NotificationsService
  ){

  }

  hoverRating(star: number) {
    this.hoveredRating = star;
  }

  resetHover() {
    this.hoveredRating = 0;
  }

  async setRating(star: number) {
    this.appointment.rating = star;
    try {
      await this.apiService.appointments.patch(this.appointment.id, { rating: this.appointment.rating })
      this.notificationService.add("success", "Appointment Rating Updated", `The rating for this apppintment was updated to ${this.appointment.rating} stars`)
    } catch(e){
      this.notificationService.add("error", "Appointment Rating Update Failed", `The rating for this apppintment was not updated`)
    }

  }

 
}
